<div class="layout-topbar p-shadow-4">
    <div class="layout-topbar-left p-xl-3 p-lg-2 p-md-1" >
        <a class="layout-topbar-logo" routerLink="/">
            <img src="assets/layout/images/naiimages/NAIGlobalLogo.png" alt="ultima-layout" style="height: 2.5rem">
        </a>
        <a class="layout-topbar-mobile-button" (click)="appMain.onTopbarMobileButtonClick($event)" pRipple>
            <i class="pi pi-ellipsis-v fs-large"></i>
        </a>
    </div>

    <div class="layout-topbar-right p-xl-9 p-lg-10 p-md-11" *ngIf="user" [ngClass]="{'layout-topbar-mobile-active': appMain.mobileTopbarActive}">
        <div class="layout-topbar-actions-left">
            <p-megaMenu [model]="model" styleClass="layout-megamenu"></p-megaMenu>
        </div>
        <div class="layout-topbar-actions-right">
            <ul class="layout-topbar-items">                    
                <li class="layout-topbar-item">
                    <a class="layout-topbar-action p-d-flex p-dir-row p-jc-center p-ai-center p-px-2" (click)="appMain.onTopbarItemClick($event, 'profile')" pRipple>
                        <img class="profilePicture" [src]="'data:image/png;base64,' + user.broker.ProfilePicture" alt="avatar" style="width: 36px; height: 36px;">
                        <span class="p-d-flex p-flex-column" [ngClass]="{'p-ml-2': !app.isRTL, 'p-mr-2': app.isRTL}">
                            <span class="p-text-bold">{{user.broker.FName}} {{user.broker.LName}}</span>
                            <small>{{user.broker.Title}}</small>
                        </span>
                        <i class="layout-inline-menu-icon pi pi-angle-down" [ngClass]="{'p-ml-3': !app.isRTL, 'p-mr-3': app.isRTL}"></i>
                    </a>
                    <ul class="layout-topbar-action-panel p-shadow-6" [@topbarActionPanelAnimation]="'visible'" *ngIf="appMain.activeTopbarItem === 'profile'">
                        <li class="layout-topbar-action-item" (click)="navigateto('profile')">
                            <span>Profile</span>
                            <!-- <a class="p-d-flex p-flex-row p-ai-center" pRipple routerLink="/user/{{user.broker.Id}}">
                               
                            </a> -->
                        </li>
                        <li class="layout-topbar-action-item" (click)="navigateto('newdeal')">
                            <span>New Deal</span>
                            <!-- <a class="p-d-flex p-flex-row p-ai-center" pRipple routerLink="/deal/new">
                                
                                
                            </a> -->
                        </li>
                        <li class="layout-topbar-action-item" [hidden]="!CanShowMenuItem()" (click)="navigateto('viewadmin')">
                            <span>Admin System Deals</span>
                            <!-- <a class="p-d-flex p-flex-row p-ai-center" pRipple routerLink="/deal/viewadmin">
                               
                                
                            </a> -->
                        </li>
                        <li class="layout-topbar-action-item" [hidden]="!CanShowMenuItem()" (click)="navigateto('reports')">
                            <span>Reports</span>
                            <!-- <a class="p-d-flex p-flex-row p-ai-center" pRipple routerLink="/reports">
                                
                                
                            </a> -->
                        </li>
                        <li class="layout-topbar-action-item"  (click)="navigateto('datamining')">
                            
                            <span>Data Mining</span>
                            <!-- <a class="p-d-flex p-flex-row p-ai-center" pRipple routerLink="/datamining-search">
                                
                                
                            </a> -->
                        </li>
                        <li class="layout-topbar-action-item" (click)="navigateto('help')">
                            <span>Help & Support</span>                          
                        </li>
                        <!-- <li class="layout-topbar-action-item">
                            <form name="PrePage" method="post" action="https://Simplecheckout.authorize.net/payment/CatalogPayment.aspx" target="_blank">
                                <input type="hidden" name="LinkId" value="d5e02e9a-ee3e-4b0e-bb9e-bfc300cbc920" />
                                <input type="submit" value="Payments" style="text-align: left; width: 100%; border: none; background-color: transparent; padding: 0; color: #212121;" />
                            </form>
                        </li> -->
                        <li class="layout-topbar-action-item">
                            <a class="p-d-flex p-flex-row p-ai-center" pRipple (click)="LogOut()">
                                <!--<i class="pi pi-cog" [ngClass]="{'p-mr-2': !app.isRTL, 'p-ml-2': app.isRTL}"></i>-->
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>
